import React, { useEffect, useRef, useState } from 'react';
import {Slider } from 'react-weui';
import { dirPlayEnd } from '@/services/course';
import styles from './styles.scss';
import { history } from 'umi';

import { Tabs, } from 'antd-mobile';
import TabDetail from './components/TabDetail';
import TabDirectory from './components/TabDirectory';
import TabComment from './components/TabComment';



export default (props) => {
  const {course} = props;

  const [tabs,setTabs] = useState([
    { title: '详情' },
    { title: '目录' },
    { title: '评论' },
  ]);

  const [page, setPage] = useState(1);
  const [playDir,setPlayDir] = useState(null);
  const [isPlay,setIsPlay] = useState(false);

  const [isPause,setIsPause] = useState(false);

  const [duration, setDuration] = useState(0);
  const [currentTime, setCurrentTime] = useState(0);

  const audioRef = useRef();
  const tabDirRef = useRef();



  function playEnd() {
    dirPlayEnd({id:playDir.id}).then(res =>{
      console.log(res);
    });

    setIsPlay(false);
  }



  return(
    <div className={styles.box}>

      <div className={styles.headerBox}>

        {playDir &&
          <audio
            src={playDir.playAddress}
            ref={audioRef}
            preload={"auto"}
            onCanPlay={(e)=>{
              setDuration(audioRef.current.duration)
            }}
            onTimeUpdate={(e)=>{
              setCurrentTime(Math.round(audioRef.current.currentTime));
            }}
            onEnded={()=> {
              playEnd();
            }}
            onPause={()=>{
              setIsPause(true);
            }}
          >

            <track src={playDir.playAddress} kind="captions" />
          </audio>}


        <img className={styles.cover} src={course.image} alt=''/>
        <img className={isPlay && !isPause ? styles.playingIcon : styles.playIcon}
             src={isPlay ? require('@/assets/music_playing.png') : require('@/assets/music_play.png')}
             onClick={()=>{
               if (isPlay) {

                 if (audioRef.current.paused) {
                   audioRef.current.play();
                   setIsPause(false);
                 } else {
                   audioRef.current.pause();
                   setIsPause(true);
                 }

               }else {
                 tabDirRef.current.defaultPlay();
               }

             }}/>

        {/*{isPlay &&*/}
        {/*<Slider className={styles.slider} min={0} max={duration} value={currentTime}*/}
                {/*onChange={(value)=> {*/}
                  {/*console.log(value);*/}
                  {/*// setCurrentTime(value);*/}
                  {/*// audioRef.current.currentTime = value;*/}
                {/*}}*/}
        {/*/>}*/}
         {/**/}
      </div>


      <Tabs
        tabs={tabs}
        initialPage={1} page={page}
        tabBarActiveTextColor={'#333333'}
        tabBarInactiveTextColor={'#888888'}
        tabBarUnderlineStyle={{backgroundColor:'transparent',height:'2'}}
        onChange={(tab, index) => { setPage(index) }}
        onTabClick={(tab, index) => { setPage(index) }}
      >
        <TabDetail course={course} goComment={() =>{
          setPage(2);
        }}/>

        <TabDirectory ref={tabDirRef} course={course}
                      playDir={(dir) => {
                        setPlayDir(dir);
                        setIsPlay(true);
                        audioRef.current.play();
                      }}
        />
        <TabComment course={course} getCommentCount={(count) => {
          setTabs([
            { title: '详情' },
            { title: '目录' },
            { title: '评论' + (count > 0 ? '('+ count+')' : '') },
          ])
        }}/>

      </Tabs>


    </div>
  )
}


